/* eslint-disable no-unused-vars */
import React from 'react'
import MainSlider from '../../Components/Slider/MainSlider'
import HomeFilter from '../../Components/Filter/HomeFilter'
import BrandSlider from '../../Components/Slider/BrandSlider'
import Services from '../../Components/Services/Services'
import Listing from '../../Components/Listing/Listing'
import CopartData from '../../Components/Copart/CopartData'
import ReviewSlider from '../../Components/Slider/ReviewSlider'

const Home = () => {

    return (
        <>
            <MainSlider />
            <HomeFilter />
            <BrandSlider />
            <Listing />
            <Services />
            <CopartData />
            <ReviewSlider />

        </>
    )
}

export default Home